
import Design from 'app/layout/Design'
import { Routes, Route } from 'react-router-dom'
import Show from 'app/layout/Show'
import CurrentDodoneResolver from 'app/dodones/CurrentResolver'
import DodoneDays from 'app/dodones/day/Index'

export default () => {
  return <div className="body">
           <Routes>
             <Route path="/" element={<CurrentDodoneResolver />} />
             <Route path="/design" element={<Design />} />
             <Route path="/dodones/days" element={<DodoneDays />} />
             <Route path="/dodones/:id" element={<Show entityName="dodone" />} />
             <Route path="/dodoables/:id" element={<Show entityName="dodoable" />} />
           </Routes>
         </div>
}
